import React from "react";
import DatesIcon from "../components/DatesIcon/DatesIcon";
import { GoDash } from "react-icons/go";
import { formatDate } from "./formatDate";
import { formatPhoneNumber } from "./formatPhoneNumber";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import WorkScreen from "../../operations/components/WorkScreen/WorkScreen";
import { useNavigate } from "react-router-dom";
import { encodeId } from "./encdec";
import "./TdGnerationCodition.css";
import AudioIcons from "../../assets/images/Audio_Icons.png";

export const TdGeneratorCondition = (
  configuration,
  data,
  eachTableData,
  onAudioHandler, // Audio handler function for playing sound
  onPDFHandler,
  onNotesHandler,
  onSelectedRowHandler,
  memberId,
  callId // Add memberId as a parameter
  // audioDuration
) => {
  const navigate = useNavigate(); // Initialize the navigate function
  const action = configuration.coloumnType;

  if (configuration.id === "workOn") {
    // Extract the status from eachTableData safely (case-insensitive)
    const status =
      eachTableData?.status ||
      eachTableData?.Status ||
      eachTableData?.STATUS ||
      "";

    // Determine if the WorkScreen should be enabled (case-insensitive)
    const status_lower = String(status).toLowerCase();
    const isEnabled =
      status_lower === "open" ||
      status_lower === "in-progress" ||
      status_lower === "closed" ||
      status_lower === "yes";

    return (
      <WorkScreen
        value={data}
        callId={eachTableData?.memberId}
        disabled={!isEnabled} // Pass the disabled prop
      />
    );
  }

  if (configuration.id === "qualityOfCall") {
    const category = (eachTableData?.callCategory || "").toLowerCase();

    if (data === null || data === undefined || data === "" || data === "N/A") {
      data = "N/A";
    } else {
      const numVal = Number(data);

      if (numVal === 0 && category.includes("short")) {
        data = "N/A";
      } else {
        data = Number(numVal.toFixed(1));
      }
    }
  }

if (configuration.id === "CRSScore") {
  const category = (eachTableData?.callCategory || "").toLowerCase();

  // Show N/A if value is null or already N/A
  if (
    data === null ||
    data === undefined ||
    data === "N/A"
  ) {
    data = "N/A";
  } else {
    const numVal = Number(data);

    if (numVal === 0 && category.includes("short")) {
      data = "N/A";
    } else {
      data = Number(numVal.toFixed(1));
    }
  }
}
  
  if (configuration.id === "agentScore") {
    data = Number(data);
    data = Number(data.toFixed(1));
  }
  if (configuration.id === "category") {
    data = data?.toString()?.toLowerCase()?.includes("undefined") ? "" : data;
  }

  if (configuration.id === "customerPhone") {
    data = formatPhoneNumber(data, "N/A");
  }

  if (configuration.id === "urgency") {
    if (data === null || data === undefined || data === "") {
      data = "N/A";
    }
  }

  switch (action) {
    case "regular":
      return (
        <p
          className={`p-0 m-0 regular-table-text text-left col-${configuration.id}`}
        >
          {data === null || data === "" || Number.isNaN(data) ? (
            <span className="font-weight-bold">
              <GoDash />
            </span>
          ) : configuration.coloumnName === "Email" ||
            typeof data === "number" ? (
            data
          ) : (
            <span className="text-capitalize">{data}</span>
          )}
        </p>
      );

    // case "audio":
    //   return (
    //     <div
    //       className="play-button"
    //       onClick={() => onAudioHandler(data)} // Trigger the audio handler with the data
    //     >
    //       {/* <FontAwesomeIcon icon={faPlay} className="play-icon" /> */}
    //       <img
    //         className="play-icon"
    //         alt="audio_img"
    //         src={AudioIcons}
    //         width={25}
    //         height={20}
    //       />
    //     </div>
    //   );

    case "audio":
      return (
        <div className="audio-cell" onClick={() => onAudioHandler(data)}>
          <img
            className="play-icon"
            alt="audio_img"
            src={AudioIcons}
            width={25}
            height={20}
          />
          {/* <div className="audio-duration">{audioDuration || "--:--"}</div> */}
          {eachTableData?.CallDuration && (
            <div className="call-duration text-muted custom-small-text mt-1">
              {eachTableData.CallDuration}
            </div>
          )}
        </div>
      );


    case "capsule-date":
      return formatDate(data) !== null ? (
        <DatesIcon data={formatDate(data)} />
      ) : (
        <p className="text-center">
          <span className="font-weight-bold">
            <GoDash />
          </span>
        </p>
      );

    case "feedback":
      return (
        <div className="feedback-status">
          <div
            className={`feedback-indicator feedback-${String(data).toLowerCase()}`}
          ></div>
          <span className="text-capitalize">{data === "0" ? "No" : "Yes"}</span>
        </div>
      );

    case "statusButton":
      return (
        <div className={`status status-${String(data).toLowerCase()}`}>
          {data === "Yes" ? "Open" : data}
        </div>
      );

    case "underlinedText":
      return (
        <div
          className="underline-text"
          onClick={() => {
            const encodedMemberId = encodeId(
              String(memberId).replace(/\s+/g, "")
            );
            const encodedCallId = encodeId(callId);
            navigate(`/detailsPage/${encodedMemberId}/${encodedCallId}`);
          }}
        >
          {data}
        </div>
      );

    default:
      return null;
  }
};
